import React from "react";
import { contactInfo } from "../mock";

const PrivacyPolicy = () => {
  return (
    <section
      id="confidentialite"
      className="bg-[#E9E1D4] py-24 md:py-28 border-t border-neutral-900/10"
      data-nav-theme="light"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-10 bg-[#9F8B76]" />
          <span className="uppercase tracking-[0.3em] text-[11px] text-neutral-500">
            Vos données
          </span>
        </div>
        <h2
          className="font-display uppercase text-neutral-900 leading-[0.95]"
          style={{ fontSize: "clamp(30px, 4vw, 60px)" }}
        >
          Politique de confidentialité
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 text-neutral-700 text-[14px] leading-relaxed">
          <div className="space-y-6">
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Responsable du traitement
              </h3>
              <p>
                Maison Labroca (SCI), SIREN 502 799 901, {contactInfo.location}
                . Contact :{" "}
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="underline decoration-neutral-300 underline-offset-4 hover:text-[#9F8B76] hover:decoration-[#9F8B76] transition-colors break-all"
                >
                  {contactInfo.email}
                </a>
              </p>
            </div>
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Données collectées
              </h3>
              <p>
                Uniquement les informations que vous saisissez volontairement
                dans le formulaire de contact : nom, adresse email, ville,
                sujet et message. Aucune autre donnée n'est collectée sur ce
                site.
              </p>
            </div>
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Finalité
              </h3>
              <p>
                Ces informations sont utilisées exclusivement pour répondre à
                votre demande de contact. Elles ne sont ni vendues, ni
                cédées, ni utilisées à des fins commerciales tierces.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Prestataire technique
              </h3>
              <p>
                Le formulaire de contact est géré par le service tiers
                Formspree, qui traite l'envoi des messages.
              </p>
            </div>
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Cookies et mesure d'audience
              </h3>
              <p>
                Avec votre accord, ce site utilise Google Analytics pour
                mesurer sa fréquentation (pages visitées, provenance des
                visiteurs). Vous pouvez accepter ou refuser ces cookies via
                la bannière affichée lors de votre première visite, et
                modifier votre choix à tout moment en effaçant les cookies
                de votre navigateur.
              </p>
            </div>
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Durée de conservation
              </h3>
              <p>
                Les messages reçus sont conservés le temps nécessaire au
                traitement de votre demande, puis supprimés.
              </p>
            </div>
            <div>
              <h3 className="text-neutral-900 font-medium mb-2 uppercase text-[11px] tracking-widest">
                Vos droits
              </h3>
              <p>
                Conformément au RGPD, vous disposez d'un droit d'accès, de
                rectification et de suppression de vos données. Pour
                l'exercer, contactez-nous à l'adresse indiquée ci-contre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
